// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"c4ff98ed","453":"25145379","574":"297739ad","842":"cab54b2c"}[chunkId] + ".chunk.js";
};